// extracted by mini-css-extract-plugin
export default {"proofCard":"styles_proofCard__od8hN","success":"styles_success__-MYDD","failed":"styles_failed__OcN8B"};